import Logo from "./Logo";

const LINKS = [
  ["Usługi", "#uslugi"],
  ["Dlaczego my", "#dlaczego"],
  ["Kontakt", "#kontakt"],
];

export default function Footer() {
  return (
    <footer className="border-t border-white/8" data-testid="footer">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-6 py-12 md:flex-row md:items-center md:px-10">
        <Logo size={34} />
        <nav aria-label="Stopka">
          <ul className="flex flex-wrap gap-x-8 gap-y-3">
            {LINKS.map(([label, href]) => (
              <li key={href}>
                <a
                  href={href}
                  data-testid={`footer-link-${href.slice(1)}`}
                  className="text-[11px] font-semibold uppercase tracking-[0.2em] text-zinc-500 transition-colors duration-300 hover:text-brand"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <p className="text-xs text-zinc-600">
          © {new Date().getFullYear()} Bass Lab – Car Audio
        </p>
      </div>
    </footer>
  );
}
